module.exports = __webpack_public_path__ + "media/site/images/banners/banner-cs-eplanning-production-mobile-c4ecdc357cd6d8cb272c282ad1334ca6.svg";